/**
 * <SessionDetailsLineSkeleton> — la forme de `<SessionDetailsLine>` pendant un premier chargement.
 *
 * La chip de la première matière (`<SubjectBadgeSkeleton>`) et une ligne de texte, à la hauteur de
 * la vraie ligne (`DETAILS_LINE_BOX`) : l'arrivée des séances ne fait rien sauter. Le cas montré est le cas
 * courant — une matière, une ligne.
 */
import React from "react"
import { View, type DimensionValue } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Skeleton } from "../../atoms/Skeleton"
import { SubjectBadgeSkeleton } from "../../atoms/SubjectBadge"
import { DETAILS_LINE_BOX } from "./SessionDetailsLine"

export type SessionDetailsLineSkeletonProps = {
    /** La barre du texte — en px ou en pourcentage de ce qui reste après la chip. */
    width: DimensionValue
    /**
     * La chip de la première matière. Défaut `true` ; `false` comme la ligne `withSubjects={false}` du
     * masteur, dont les élèves portent les matières : le texte seul, à la même hauteur.
     */
    withSubject?: boolean
}

export function SessionDetailsLineSkeleton(props: SessionDetailsLineSkeletonProps) {
    const { width, withSubject = true } = props

    return (
        <Row gap="2" align="center" style={styles.line}>
            {withSubject && <SubjectBadgeSkeleton />}
            <View style={styles.fill}>
                <Skeleton textSize="text-sm" width={width} />
            </View>
        </Row>
    )
}

const styles = StyleSheet.create(() => ({
    line: { height: DETAILS_LINE_BOX.height },
    fill: { flex: 1, flexShrink: 1 },
}))
